/**
 * Created by RanAn on 2021/05/01.
 */
/* jshint esversion: 8 */
import CancelDailPercentChart from './components/charts/CancelDailPercentChart';
import AssistantTelphoneProcessCountChart from './components/charts/AssistantTelphoneProcessCountChart';
import AssistantF2FProcessCountChart from './components/charts/AssistantF2FProcessCountChart';
import ChatbotProcessCountChart from './components/charts/ChatbotProcessCountChart';
import ChatbotOperateCountChart from './components/charts/ChatbotOperateCountChart';
import ChatbotPeriodCountChart from './components/charts/ChatbotPeriodCountChart';
import ChatbotSurveyEvaluateChart from './components/charts/ChatbotSurveyEvaluateChart';
import ChatbotSurveyEvaluateBySMSChart from './components/charts/ChatbotSurveyEvaluateBySMSChart';
import ChatbotQuestionChart from './components/charts/ChatbotQuestionChart';
import ChatbotAnswerChart from './components/charts/ChatbotAnswerChart';
import TelephoneAnswerChart from './components/charts/TelephoneAnswerChart';
import F2FAnswerChart from './components/charts/F2FAnswerChart';
import TelephoneTalkWorkCountChart from './components/charts/TelephoneTalkWorkCountChart';
import TelphoneAnswersChooseChart from './components/charts/TelphoneAnswersChooseChart';
import F2FAnswersChooseChart from './components/charts/F2FAnswersChooseChart';
import TelphoneNGWordsChart from './components/charts/TelphoneNGWordsChart';
import TelphoneAverageTimeChart from './components/charts/TelphoneAverageTimeChart';
import ChatbotSupportAverageTimeChart from './components/charts/ChatbotSupportAverageTimeChart';
import F2FNGWordsChart from './components/charts/F2FNGWordsChart';
import TelphoneStatusTimesChart from './components/charts/TelphoneStatusTimesChart';
import F2FStatusTimesChart from './components/charts/F2FStatusTimesChart';
import BuzzWordMapChart from './components/charts/BuzzWordMapChart';
import SuspectedAlertCount from './components/charts/SuspectedAlertCount';
import VoicebotAnswerChart from './components/charts/VoicebotAnswerChart';
import VoicebotCallDurationDistributionChart from './components/charts/VoicebotCallDurationDistributionChart';  // Import new call duration distribution chart component
import ResponseTypeCountChart from './components/charts/ResponseTypeCountChart';

import PresenceSupervisorHelpAlertCount from './components/charts/PresenceSupervisorHelpAlertCount';
import ChatSupervisorHelpAlertCount from './components/charts/ChatSupervisorHelpAlertCount';
import TelSupervisorHelpAlertCount from './components/charts/TelSupervisorHelpAlertCount';
import F2FSupervisorHelpAlertCount from './components/charts/F2FSupervisorHelpAlertCount';

import PresenceNgWordsAlertCount from './components/charts/PresenceNgWordsAlertCount';
import ChatNgWordsAlertCount from './components/charts/ChatNgWordsAlertCount';
import TelNgWordsAlertCount from './components/charts/TelNgWordsAlertCount';
import F2FNgWordsAlertCount from './components/charts/F2FNgWordsAlertCount';
import ForecastAlertCount from './components/charts/ForecastAlertCount';
import PresenceLongTimeAlertCount from './components/charts/PresenceLongTimeAlertCount';
import TelLongTimeAlertCount from './components/charts/TelLongTimeAlertCount';
import PersonConfirmAlertCount from './components/charts/PersonConfirmAlertCount';

import PresenceStatusChart from './components/charts/PresenceStatusChart';
import PresenceModeChart from './components/charts/PresenceModeChart';

import ChatAnswerStatusChart from './components/charts/ChatAnswerStatusChart';
import ChatStatusChart from './components/charts/ChatStatusChart';
import ChatPersonStatusChart from './components/charts/ChatPersonStatusChart';

import TelStatusChart from './components/charts/TelStatusChart';
import TelReleaseStatusChart from './components/charts/TelReleaseStatusChart';

import F2FStatusChart from './components/charts/F2FStatusChart';

import ChatbotSupportAnswerChart from './components/charts/ChatbotSupportAnswerChart';
import ChatbotSupportCustomerSurveyEvaluateCountChart from './components/charts/ChatbotSupportCustomerSurveyEvaluateCountChart';
import ChatbotSupportSurveyEvaluateCountChart from './components/charts/ChatbotSupportSurveyEvaluateCountChart';
import ChatbotSupportTicketTimeCountChart from './components/charts/ChatbotSupportTicketTimeCountChart';
import ChatbotSupportCompatibilityLevelChart from './components/charts/ChatbotSupportCompatibilityLevelChart';
export default {
    install: function (Vue) {
        Vue.component('CancelDailPercentChart', CancelDailPercentChart);
        Vue.component('AssistantTelphoneProcessCountChart', AssistantTelphoneProcessCountChart);
        Vue.component('AssistantF2FProcessCountChart', AssistantF2FProcessCountChart);
        Vue.component('ChatbotProcessCountChart', ChatbotProcessCountChart);
        Vue.component('ChatbotOperateCountChart', ChatbotOperateCountChart);
        Vue.component('ChatbotPeriodCountChart', ChatbotPeriodCountChart);
        Vue.component('ChatbotSurveyEvaluateChart', ChatbotSurveyEvaluateChart);
        Vue.component('ChatbotSurveyEvaluateBySMSChart', ChatbotSurveyEvaluateBySMSChart);
        Vue.component('TelephoneAnswerChart', TelephoneAnswerChart);
        Vue.component('F2FAnswerChart', F2FAnswerChart);
        Vue.component('TelephoneTalkWorkCountChart', TelephoneTalkWorkCountChart);
        Vue.component('TelphoneAnswersChooseChart', TelphoneAnswersChooseChart);
        Vue.component('F2FAnswersChooseChart', F2FAnswersChooseChart);
        Vue.component('TelphoneNGWordsChart', TelphoneNGWordsChart);
        Vue.component('TelphoneAverageTimeChart', TelphoneAverageTimeChart);
        Vue.component('ChatbotSupportAverageTimeChart', ChatbotSupportAverageTimeChart);
        Vue.component('F2FNGWordsChart', F2FNGWordsChart);
        Vue.component('TelphoneStatusTimesChart', TelphoneStatusTimesChart);
        Vue.component('F2FStatusTimesChart', F2FStatusTimesChart);
        Vue.component('ChatbotQuestionChart', ChatbotQuestionChart);
        Vue.component('ChatbotAnswerChart', ChatbotAnswerChart);
        Vue.component('ForecastAlertCount', ForecastAlertCount);
        Vue.component('BuzzWordMapChart', BuzzWordMapChart);
        Vue.component('PresenceNgWordsAlertCount', PresenceNgWordsAlertCount);
        Vue.component('ChatNgWordsAlertCount', ChatNgWordsAlertCount);
        Vue.component('TelNgWordsAlertCount', TelNgWordsAlertCount);
        Vue.component('F2FNgWordsAlertCount', F2FNgWordsAlertCount);
        Vue.component('SuspectedAlertCount', SuspectedAlertCount);
        Vue.component('VoicebotAnswerChart',VoicebotAnswerChart)
        Vue.component('VoicebotCallDurationDistributionChart', VoicebotCallDurationDistributionChart);  // Register new call duration distribution chart component
        Vue.component('ResponseTypeCountChart', ResponseTypeCountChart);

        Vue.component('PresenceSupervisorHelpAlertCount', PresenceSupervisorHelpAlertCount);
        Vue.component('ChatSupervisorHelpAlertCount', ChatSupervisorHelpAlertCount);
        Vue.component('TelSupervisorHelpAlertCount', TelSupervisorHelpAlertCount);
        Vue.component('F2FSupervisorHelpAlertCount', F2FSupervisorHelpAlertCount);

        Vue.component('PresenceLongTimeAlertCount', PresenceLongTimeAlertCount);
        Vue.component('TelLongTimeAlertCount', TelLongTimeAlertCount);
        Vue.component('PersonConfirmAlertCount', PersonConfirmAlertCount);
        Vue.component('PresenceStatusChart', PresenceStatusChart);
        Vue.component('PresenceModeChart', PresenceModeChart);
        Vue.component('ChatAnswerStatusChart', ChatAnswerStatusChart);
        Vue.component('ChatStatusChart', ChatStatusChart);
        Vue.component('ChatPersonStatusChart', ChatPersonStatusChart);
        Vue.component('TelStatusChart', TelStatusChart);
        Vue.component('TelReleaseStatusChart', TelReleaseStatusChart);
        Vue.component('F2FStatusChart', F2FStatusChart);
        Vue.component('ChatbotSupportAnswerChart', ChatbotSupportAnswerChart);
        Vue.component('ChatbotSupportCustomerSurveyEvaluateCountChart', ChatbotSupportCustomerSurveyEvaluateCountChart);
        Vue.component('ChatbotSupportSurveyEvaluateCountChart', ChatbotSupportSurveyEvaluateCountChart);
        Vue.component('ChatbotSupportTicketTimeCountChart', ChatbotSupportTicketTimeCountChart);
        Vue.component('ChatbotSupportCompatibilityLevelChart', ChatbotSupportCompatibilityLevelChart);
    }
}
